module.exports = {"appId":"fulfillment","appUrl":"staging.scanshipco.com","appVersion":"api","useSSL":true,"currentVersion":""}


//////////////////
// WEBPACK FOOTER
// ./src/config/staging/application-settings.json
// module id = 3076
// module chunks = 1